import script from "./SystemSetupForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemSetupForm.vue?vue&type=script&setup=true&lang=js"

import "./SystemSetupForm.vue?vue&type=style&index=0&id=51c53e11&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51c53e11"]])

export default __exports__